.m-field {
  position: relative;

  &__label {
    display: block;
    font-size: 0.75rem;
    color: var(--grey-darkest);
    line-height: 1.2;
    margin-bottom: 4px;
  }

  &__content {
    font-size: 1rem;
    color: var(--text-color);
  }
}
